<script setup lang="ts">
import { useI18n } from 'vue-i18n'

import UiCta from '@/components/common/UiCta.vue'
import { useHomeFormCtaTarget } from '@/composables/useHomeFormCtaTarget'
import { env } from '@/utils/env'
import ColorProfilePicker from './ColorProfilePicker.vue'
import DarkToggle from './DarkToggle.vue'
import DevTestSwitcher from './DevTestSwitcher.vue'
import LanguageSwitcher from './LanguageSwitcher.vue'

const props = withDefaults(defineProps<{
  testSwitcherOpen?: boolean
}>(), {
  testSwitcherOpen: false,
})

const emit = defineEmits<{
  (e: 'interact'): void
  (e: 'update:testSwitcherOpen', value: boolean): void
}>()

const { t } = useI18n()
const { homePath, targetEl: homeFormTargetEl } = useHomeFormCtaTarget()

function handleInteract() {
  emit('interact')
}

function handleTestSwitcherOpenChange(value: boolean) {
  emit('update:testSwitcherOpen', value)
}
</script>

<template>
  <div
    class="utility-control ml-auto lg:ml-0"
    @pointerdown.capture="handleInteract"
    @focusin.capture="handleInteract"
  >
    <LanguageSwitcher />
    <DevTestSwitcher
      v-if="env.isDev"
      :open="props.testSwitcherOpen"
      @update:open="handleTestSwitcherOpenChange"
    />
    <ColorProfilePicker v-if="env.isDev" />
    <DarkToggle />
    <UiCta
      class="!hidden lg:!inline-flex"
      :options="{
        type: 'scroll',
        to: homePath,
        text: t('cta.survey'),
        color: 'primary',
        targetEl: homeFormTargetEl
      }"
    />
  </div>
</template>
